import { Stack, Typography, Box } from '@mui/material';
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';

export default function SearchNotFound({
    title = "No Results Found",
    subtitle = "We couldn’t find any matching records for your search.",
    height = 260,
}) {
    return (
        <Stack
            direction="column"
            alignItems="center"
            justifyContent="center"
            spacing={2}
            sx={{
                width: '100%',
                height,
                p: 3,
            }}
        >
            {/* ICON */}
            <Box
                sx={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    backgroundColor: '#f1f1f1',

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <SearchOffRoundedIcon
                    sx={{
                        fontSize: 38,
                        color: '#9b9b9b',
                    }}
                />
            </Box>

            {/* TEXT */}
            <Stack spacing={0.5} alignItems="center">
                <Typography
                    sx={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: '#222',
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    sx={{
                        fontSize: 14,
                        color: '#7b7b7b',
                        textAlign: 'center',
                        maxWidth: 320,
                    }}
                >
                    {subtitle}
                </Typography>
            </Stack>
        </Stack>
    );
}